"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _reactTransitionGroup = require("react-transition-group");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Message extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessageTimestamp: false
    };

    this.toggleShowTimestamp = e => {
      e.preventDefault();
      const {
        showMessageTimestamp
      } = this.state;
      this.setState({
        showMessageTimestamp: !showMessageTimestamp
      });
    };

    this.messageTimestampRef = /*#__PURE__*/_react.default.createRef();
  }

  render() {
    const {
      message,
      isMine,
      startsSequence,
      endsSequence,
      showTimestamp
    } = this.props;
    const {
      showMessageTimestamp
    } = this.state;
    const friendlyTimestamp = (0, _moment.default)(message.createDate).format('LLLL');
    return /*#__PURE__*/_react.default.createElement("div", {
      className: ['message', `${isMine ? 'mine' : ''}`, `${startsSequence ? 'start' : ''}`, `${endsSequence ? 'end' : ''}`].join(' ')
    }, showTimestamp && /*#__PURE__*/_react.default.createElement("div", {
      className: "timestamp"
    }, friendlyTimestamp), /*#__PURE__*/_react.default.createElement("div", {
      className: "bubble-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "bubble",
      title: friendlyTimestamp,
      onClick: this.toggleShowTimestamp
    }, message.body)), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      in: showMessageTimestamp,
      appear: true,
      timeout: 400,
      classNames: "message-timestamp-transition",
      unmountOnExit: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: this.messageTimestampRef,
      className: "message-timestamp"
    }, friendlyTimestamp)));
  }

}

var _default = Message;
exports.default = _default;